import * as t from "io-ts";
import { AxiosResponse } from "axios";

import customAxios from "./customAxios";
import { decodeAxiosResponse } from "./decodeAxiosResponse";
import { LabelClass, labelClassCodec } from "../datamodel/labelClass";

export const listLabelClasses = async (): Promise<AxiosResponse<LabelClass[]>> =>
  decodeAxiosResponse(t.array(labelClassCodec))(await customAxios.get("/api/label-classes"));
